import styled from "styled-components";
import { colors } from "../../../common/ui/globalColors";

export const StyledTenantsCard = styled.div`
    background: ${colors.semiTransparentColors.white};
    border: 1px solid ${colors.additionalColors.lightBlue};
    box-shadow: 0px 3px 34px ${colors.semiTransparentColors.darkGray};
    border-radius: 11px;
    padding: 15px 40px;
    display: grid;
    gap: 5px;
    grid-template-columns: 0.5fr 2fr 2fr 2fr 2fr;
    color: ${colors.semiTransparentColors.grayBlue};
    text-align: center;
    align-items: center;
    font-size: 14px;
    line-height: 16px;

    .icons {
        display: flex;
        gap: 5px;
    }

    .tenant-type {
        font-weight: 700;
        color: ${colors.textColors.black};
    }
`